import React from 'react';
import { Paper } from '@mui/material';
import { useOtpFlow } from '../hooks';
import DeliverySelector from './DeliverySelector';
import OtpCodeInput from './OtpCodeInput';
import OtpErrorDisplay from './OtpErrorDisplay';
import InvalidLinkNotice from './InvalidLinkNotice';

const OtpFlow: React.FC = () => {
  const {
    reportPayload,
    reportParam,
    otpStage,
    selectedDelivery,
    otpError,
    otpErrorCode,
    attemptsRemaining,
    isLoading,
    setSelectedDelivery,
    handleSendOtp,
    handleVerifyOtp,
    handleRetry,
  } = useOtpFlow();

  if (!reportPayload) {
    if (!reportParam) {
      return <InvalidLinkNotice />;
    }
    return null; // Still decoding
  }

  return (
    <Paper sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
      {otpStage === 'delivery_select' && (
        <DeliverySelector
          report={reportPayload}
          selected={selectedDelivery}
          onChange={setSelectedDelivery}
          onSend={handleSendOtp}
          isLoading={isLoading}
        />
      )}

      {(otpStage === 'code_entry' || otpStage === 'verifying') && (
        <OtpCodeInput
          onVerify={handleVerifyOtp}
          onResend={handleSendOtp}
          isLoading={isLoading}
          attemptsRemaining={attemptsRemaining}
          error={otpError}
        />
      )}

      {otpStage === 'error' && (
        <OtpErrorDisplay
          error={otpError || 'An error occurred'}
          errorCode={otpErrorCode}
          onRetry={handleRetry}
        />
      )}
    </Paper>
  );
};

export default OtpFlow;
